import { useId } from 'react';

export const ZoomIcon = ({ className }: { className?: string }) => {
  const uid = useId();
  const a = `${uid}-a`;

  return (
    <svg
      className={className}
      viewBox="0 0 296 296"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={`url(#${a})`}
        d="M295.44 147.72C295.44 163.38 294.26 179.04 291.6 194.1C283.62 244.03 244.03 283.62 194.1 291.6C179.03 294.26 163.37 295.44 147.72 295.44C132.07 295.44 116.4 294.26 101.34 291.6C51.41 283.62 11.82 244.03 3.84003 194.1C1.18003 179.03 0 163.37 0 147.72C0 132.07 1.18003 116.4 3.84003 101.34C11.82 51.41 51.41 11.82 101.34 3.84C116.41 1.18 132.07 0 147.72 0C163.37 0 179.04 1.18 194.1 3.84C244.03 11.82 283.62 51.41 291.6 101.34C294.26 116.41 295.44 132.07 295.44 147.72Z"
      />
      <path
        fill="#fff"
        d="M124.41 194.48H48.67C43.66 194.48 38.91 191.85 36.6 187.36C33.97 182.23 34.93 176.07 38.97 172.03L91.67 119.38C74.72 117.41 35.58 128.09 35.12 100.59H104.89C109.9 100.59 114.65 103.22 116.96 107.71C119.59 112.84 118.63 119 114.59 123.04L61.89 175.69H105.6C116 175.69 124.41 184.09 124.41 194.48Z"
      />
      <path
        fill="#fff"
        d="M223.1 99.8896C212.25 99.8896 202.49 104.57 195.82 112.07C174.84 86.9096 130.86 104.3 131.95 137.15V195.19C159.92 194.65 148.59 154.24 150.76 136.96C151.04 113.21 185.88 112.81 186.45 136.51V176.4C186.45 186.79 194.86 195.19 205.26 195.19V136.96C205.55 113.2 240.38 112.82 240.95 136.51V176.4C240.95 186.79 249.36 195.19 259.75 195.19C257.9 163.65 272.06 101.15 223.1 99.8896Z"
      />
      <defs>
        <linearGradient
          id={a}
          x1="69.25"
          x2="225.41"
          y1="281.9"
          y2="13.1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0845BF" />
          <stop offset=".19" stopColor="#0950DE" />
          <stop offset=".38" stopColor="#0B59F6" />
          <stop offset=".5" stopColor="#0B5CFF" />
          <stop offset=".67" stopColor="#0E5EFE" />
          <stop offset=".78" stopColor="#1665FC" />
          <stop offset=".86" stopColor="#246FF9" />
          <stop offset=".94" stopColor="#387FF4" />
          <stop offset="1" stopColor="#4F90EE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
